import type { ISearchAlias } from './types'

export const searchAliases: ISearchAlias[] = [
  { label: 'widget.deposits_search_aliases.best_for_half_year', param: 'period', value: '6' },
  { label: 'widget.deposits_search_aliases.best_for_year', param: 'period', value: '12' },
  { label: 'widget.deposits_search_aliases.best_for_two_years', param: 'period', value: '24' },
  { label: 'widget.deposits_search_aliases.best_in_kgs', param: 'currency', value: 'kgs' },
  { label: 'widget.deposits_search_aliases.best_in_usd', param: 'currency', value: 'usd' },
  { label: 'widget.deposits_search_aliases.best_in_rub', param: 'currency', value: 'rub' }
]
